import {
  usePandaDocSyncStatusQuery,
  PandaDocSyncStatusQuery,
} from 'core/graphql';

export type PandaDocSyncStatus = NonNullable<
  PandaDocSyncStatusQuery['pandadocSyncStatus']
>;

interface IPandaDocSyncStatusHook {
  status?: PandaDocSyncStatus;
  loading: boolean;
}

/**
 * Sync health for the dashboard banner: how many documents still lack their
 * details (so conversion analytics is still incomplete) and when sync last ran.
 */
export const usePandaDocSyncStatus = (): IPandaDocSyncStatusHook => {
  const { data, loading } = usePandaDocSyncStatusQuery({
    fetchPolicy: 'cache-and-network',
  });

  return {
    status: data?.pandadocSyncStatus ?? undefined,
    loading,
  };
};
